export default [
    {
        package: "Internal Pkg #1",
        name: "Start-up",
        id: 0,
        price: 300.00,
        info01: "* Notion.so Team Workspace (1 year plan for 1 Team-member)",
        info02: "* Add digital documents/policies to workspace",
        info03: "* Add a page with links to common tools used by employees",
        info04: "* 10 page total including documents",
        finished: "Typical turn-around for this package is 7-10 Business Days",
    },
];